<template>
  <EventsCoursesListWithFiltersWrapper
    :title="$t('events.past_courses')"
    :event-type="EventType.Course"
    :list-type="
      authStore.auth ? EventsListTypeMap.MePast : EventsListTypeMap.Past
    "
  >
    <template #empty>
      <div class="py-4">
        <template v-if="eventsStore.filtersCount > 0">
          {{ $t('events.no_courses_with_filters') }}
        </template>
        <template v-else>
          {{ $t('events.no_courses') }}
        </template>
      </div>
    </template>
  </EventsCoursesListWithFiltersWrapper>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'
import { EventType, EventsListTypeMap } from '~/models/events'

const authStore = useAuth()
const eventsStore = useEvents()

useHeadMeta({
  title: 'Past courses',
  description: 'Past courses in WN Academy',
})
</script>
